/*
  Moriox: free Shoe Tree on orders of 10,000 PKR+   (v8, Kalles safe)

  What it does
  - progress bar under the "SHOPPING CART" heading of the drawer
  - adds the Shoe Tree when the cart reaches the threshold, removes it again when it drops below
  - the price becomes Rs.0 through the "Free Shoe Tree" automatic discount (set up in Shopify admin)

  Why delete needed several clicks (v4 - v6), and what v7 does about it
  - Shopify puts a newly added item at the TOP of the cart. When the script adds the Shoe Tree, every
    product moves one line down; when it removes it, they move one line up. Kalles deletes by line
    number ("delete line 1"). If the drawer was not redrawn in that moment, "line 1" was the Shoe Tree,
    not the product the customer clicked, so the wrong item was deleted and the product needed more clicks.
  - v5/v6 tried to read the row order from hidden item codes in the drawer. Kalles does not always print
    those codes, and then the fix silently did nothing.
  - v7 remembers WHICH product the customer clicked. It recognises the row by the product name shown in
    it (or by its item code / variant link when Kalles prints one). When Kalles then sends
    "change line N" and line N is not that product, the request is sent for the clicked product instead.
    This happens instantly, without waiting for anything, so no click is lost.
  - if the clicked row belongs to an item that is no longer in the cart (e.g. the Shoe Tree the script
    just removed), Shopify gets a harmless "no change" request instead of an error, and the drawer is redrawn.
  - v8: the script NEVER changes the theme's drawer HTML any more (only its own progress bar). v7 redrew
    and tidied the drawer itself; Kalles keeps references to its drawer parts, so after a delete the drawer
    could stay on the grey loading skeleton, and products could vanish from it. Now the script only sends
    the usual "cart changed" signal and lets Kalles redraw its own drawer.
  - Shopify can give an item a new code when the free-gift discount starts/stops applying; old codes
    still shown in the drawer are translated to the current one.

  How it stays out of the theme's way
  - it never reloads the page and never blocks or delays a click
  - only a theme /cart/change request is ever touched, and only when it does not match the row clicked
  - it LISTENS for the theme's cart requests (PerformanceObserver) and checks the cart once after each
  - if the customer deletes the free Shoe Tree himself, it is not added back until the cart
    goes below the threshold and reaches it again
  - safety brake: after 4 changes in 20 seconds it pauses itself for a minute
  To switch it off completely: remove the <script> line from theme.liquid.
*/
(function () {
  'use strict';
  if (window.__mrxGiftLoaded || !window.fetch) return;
  window.__mrxGiftLoaded = true;

  // ====== SETTINGS ======
  var CONFIG = {
    thresholdPkr: 10000,            // free gift from this subtotal
    giftVariantId: 47848957247713,  // Moriox Adjustable Shoe Tree (variant id)
    giftName: 'Shoe Tree',          // used in the bar text
    removeManualGift: false,        // true = also remove a Shoe Tree the customer added himself when below the threshold
    refreshTheme: true,             // after adding/removing the gift, ask the theme to redraw its drawer
    debug: false                    // true = print what the script is doing in the browser console
  };
  // ======================

  var THRESHOLD = CONFIG.thresholdPkr * 100;   // Shopify prices are in paisa
  var GIFT = CONFIG.giftVariantId;
  var TAG = 'mrx=1';                            // our own requests carry this, so we never react to them
  var CART_CHANGE = /\/cart\/(add|change|update|clear)(\.js|\.json)?(\?|#|$)/;
  var CART_LINE_REQ = /\/cart\/change(\.js|\.json)?(\?|#|$)/;
  var FLAG_KEY = 'mrx_gift_state';              // '' | 'added' | 'dismissed'
  var BAR_ID = 'mrx-gift-bar';
  var CLICK_TTL = 6000;                         // a click explains a cart request sent within this time
  var REGION_SEL = '[id*="cart" i],[class*="cart" i],[id*="drawer" i],[class*="drawer" i],form[action*="/cart"]';

  var nativeFetch = window.fetch;               // our own requests never go through the wrapper
  var busy = false, again = false, ran = false, timer = null;
  var view = null;                              // what the bar shows
  var actionLog = [], pausedUntil = 0, failUntil = 0, lastRefresh = 'none', lastFix = 'none';
  var header = null, bar = null, watched = null, mo = null, barTimer = null, resyncTimer = null;
  var seq = 0, lastDrift = 0, t0 = Date.now(), traceLog = [];
  var lastCart = null;                          // the cart as Shopify last returned it
  var currentKeys = {};                         // item keys in lastCart
  var knownItems = {};                          // every item seen in this visit (also ones already removed)
  var knownVariants = {}; knownVariants[String(GIFT)] = true;
  var lastClick = null;                         // { key, t }: the cart row the customer touched last

  function now() { return Date.now(); }
  function norm(s) { return String(s == null ? '' : s).toLowerCase().replace(/\s+/g, ' ').trim(); }
  function log() {
    if (!CONFIG.debug || !window.console) return;
    console.log.apply(console, ['[free-gift]'].concat([].slice.call(arguments)));
  }
  function trace(msg) {
    traceLog.push(((now() - t0) / 1000).toFixed(1) + 's ' + msg);
    if (traceLog.length > 30) traceLog.shift();
    log(msg);
  }

  // ---------- tiny storage helpers (storage can be blocked) ----------
  function getFlag() { try { return sessionStorage.getItem(FLAG_KEY) || ''; } catch (e) { return ''; } }
  function setFlag(v) { try { sessionStorage.setItem(FLAG_KEY, v); } catch (e) { /* ignore */ } }

  // ---------- cart helpers ----------
  function isTree(i) { return i.variant_id === GIFT; }
  function isAuto(i) { return isTree(i) && i.properties && i.properties._free_gift; }
  function money(c) { return 'Rs.' + Math.ceil(c / 100).toLocaleString('en-US'); }
  function label(key) { var k = knownItems[key]; return k ? k.title.slice(0, 24) : String(key).slice(0, 12); }

  // store a full cart (from cart.js or from the answer to the theme's own cart request)
  var currentByVariant = {};                    // variant id -> item keys in lastCart
  function remember(c) {
    if (!c || !Array.isArray(c.items) || typeof c.item_count !== 'number') return;
    lastCart = c;
    currentKeys = {};
    currentByVariant = {};
    c.items.forEach(function (i) {
      var v = String(i.variant_id);
      knownItems[i.key] = { key: i.key, variant: v, title: norm(i.product_title), vtitle: norm(i.variant_title) };
      currentKeys[i.key] = 1;
      (currentByVariant[v] = currentByVariant[v] || []).push(i.key);
      knownVariants[v] = true;
    });
  }

  // Shopify can give an item a NEW code (key) when a discount starts or stops applying (e.g. the free
  // Shoe Tree discount). An old code still printed in the drawer is translated to the item's current code.
  function canonical(k) {
    if (!k || currentKeys[k]) return k;
    var it = knownItems[k];
    var same = it && currentByVariant[it.variant];
    return same && same.length === 1 ? same[0] : k;
  }
  function uniq(list) {
    var seen = {}, out = [];
    for (var i = 0; i < list.length; i++) if (!seen[list[i]]) { seen[list[i]] = 1; out.push(list[i]); }
    return out;
  }
  // an item is really gone only if nothing of the same product/size is still in the cart
  function isGone(k) {
    if (!k || currentKeys[canonical(k)]) return false;
    var it = knownItems[k];
    if (!it) return false;
    for (var ck in currentKeys) { var c = knownItems[ck]; if (c && c.title === it.title && c.vtitle === it.vtitle) return false; }
    return true;
  }

  function getCart() {
    return nativeFetch.call(window, '/cart.js', { cache: 'no-store', credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { if (!r.ok) throw new Error('cart.js ' + r.status); return r.json(); })
      .then(function (c) { remember(c); return c; });
  }

  function post(path, body) {
    return nativeFetch.call(window, path + (path.indexOf('?') > -1 ? '&' : '?') + TAG, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    });
  }

  function measure(cart) {
    var items = cart.items || [];
    var others = items.filter(function (i) { return !isTree(i); });
    var eligible = others.reduce(function (s, i) { return s + i.original_line_price; }, 0);
    return {
      items: items,
      others: others,
      gifts: items.filter(isTree),
      autoLines: items.filter(isAuto),
      eligible: eligible,
      hasItems: others.length > 0,
      unlocked: others.length > 0 && eligible >= THRESHOLD
    };
  }

  // decide what (if anything) must change in the cart. Idempotent: asking twice gives the same answer.
  function decide(m) {
    var st = getFlag();
    if (!m.unlocked) {
      if (st) setFlag('');
      var rm = CONFIG.removeManualGift ? m.gifts : m.autoLines;
      return rm.length ? { type: 'remove', keys: rm.map(function (i) { return i.key; }) } : null;
    }
    if (m.gifts.length) { if (st !== 'added') setFlag('added'); return null; }
    if (st === 'added') { setFlag('dismissed'); return null; }   // customer removed it, respect that
    if (st === 'dismissed') return null;
    return { type: 'add' };
  }

  async function perform(action) {
    var t = now();
    actionLog = actionLog.filter(function (x) { return t - x < 20000; });
    if (t < pausedUntil || t < failUntil) return false;
    if (actionLog.length >= 4) {
      pausedUntil = t + 60000;
      if (window.console) console.warn('[free-gift] too many cart changes, pausing for 60s');
      return false;
    }
    actionLog.push(t);

    if (action.type === 'add') {
      var r = await post('/cart/add.js', { items: [{ id: GIFT, quantity: 1, properties: { _free_gift: 'true' } }] });
      if (!r.ok) { failUntil = now() + 60000; trace('add failed ' + r.status); return false; }
      setFlag('added');
      return true;
    }
    var changed = false;
    for (var i = 0; i < action.keys.length; i++) {
      var rr = await post('/cart/change.js', { id: action.keys[i], quantity: 0 });
      if (rr.ok) changed = true; else { failUntil = now() + 60000; trace('remove failed ' + rr.status); }
    }
    return changed;
  }

  // =====================================================================
  //  Which cart item does an element belong to?
  // =====================================================================
  var KEY_G = /\d{6,}(?::|%3A)[0-9a-f]{20,}/ig;   // item keys, e.g. 47848957247713:3f9a0c... (also URL-encoded)
  var VARIANT_RE = /[?&]variant=(\d+)/;

  function esc(s) { return s.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); }
  function hasWord(text, w) { return new RegExp('(^|[^a-z0-9])' + esc(w) + '([^a-z0-9]|$)').test(text); }

  // visible words of an element, with a space between separate pieces of text ("Shoes" + "43" stays two words)
  function nodeText(node) {
    var parts = [], w = (node.ownerDocument || document).createTreeWalker(node, NodeFilter.SHOW_TEXT, null, false), t;
    while ((t = w.nextNode())) {
      var p = t.parentNode;
      if (p && /^(SCRIPT|STYLE|NOSCRIPT|TEMPLATE)$/.test(p.nodeName)) continue;
      if (bar && bar.contains(t)) continue;
      parts.push(t.nodeValue);
    }
    return norm(parts.join(' '));
  }

  function elementsOf(node) { return [node].concat([].slice.call(node.getElementsByTagName('*'))); }

  function keysIn(els) {
    var found = {};
    for (var i = 0; i < els.length; i++) {
      var at = els[i].attributes;
      if (!at) continue;
      for (var j = 0; j < at.length; j++) {
        var v = at[j].value;
        if (!v || v.length > 2000) continue;
        var ms = v.match(KEY_G);
        if (!ms) continue;
        for (var k = 0; k < ms.length; k++) {
          var key = ms[k].replace(/%3A/i, ':').toLowerCase();
          if (knownItems[key]) found[canonical(key)] = 1;
        }
      }
    }
    return Object.keys(found);
  }

  function variantKeysIn(els) {
    var vars = {}, out = [];
    for (var i = 0; i < els.length; i++) {
      if (els[i].nodeName !== 'A') continue;
      var mv = VARIANT_RE.exec(els[i].getAttribute('href') || '');
      if (mv && knownVariants[mv[1]]) vars[mv[1]] = 1;
    }
    for (var k in knownItems) if (vars[knownItems[k].variant]) out.push(canonical(k));
    return uniq(out);
  }

  // product names in a piece of text, longest first so "Shoe Tree" never counts inside "Shoe Tree Deluxe"
  function titlesIn(text) {
    if (!text) return [];
    var seen = {}, titles = [], k, i, hit = [];
    for (k in knownItems) { var t = knownItems[k].title; if (t && !seen[t]) { seen[t] = 1; titles.push(t); } }
    titles.sort(function (a, b) { return b.length - a.length; });
    var rest = text;
    for (i = 0; i < titles.length; i++) {
      if (rest.indexOf(titles[i]) > -1) { hit.push(titles[i]); rest = rest.split(titles[i]).join(' | '); }
    }
    if (hit.length) return hit;
    // the theme may shorten long names: try the first 20 letters
    for (i = 0; i < titles.length; i++) {
      if (titles[i].length > 20 && rest.indexOf(titles[i].slice(0, 20)) > -1) hit.push(titles[i]);
    }
    return hit;
  }

  function pick(cands, text) {
    cands = uniq(cands.map(canonical));
    if (!cands.length) return { state: 'none' };
    if (cands.length === 1) return { state: 'one', key: cands[0] };
    // several items of the same product (different sizes): the variant name shown in the row decides
    var byV = cands.filter(function (k) {
      var v = knownItems[k].vtitle;
      return v && v !== 'default title' && hasWord(text, v);
    });
    if (byV.length === 1) return { state: 'one', key: byV[0] };
    return { state: 'many' };
  }

  // { state: 'none' | 'one' | 'many', key }
  function identify(node) {
    var els = elementsOf(node);
    var text = nodeText(node);
    var ks = keysIn(els);
    if (ks.length) return ks.length === 1 ? { state: 'one', key: ks[0] } : { state: 'many' };
    var vs = variantKeysIn(els);
    if (vs.length) return pick(vs, text);
    var ts = titlesIn(text);
    if (!ts.length) return { state: 'none' };
    if (ts.length > 1) return { state: 'many' };
    var cands = [];
    for (var k in knownItems) if (knownItems[k].title === ts[0]) cands.push(k);
    return pick(cands, text);
  }

  // the cart part of the page an element is in (the drawer, or the cart page form)
  function regionOf(t) {
    var r = null;
    for (var n = t; n && n.nodeType === 1 && n !== document.body; n = n.parentElement) {
      try { if (n.matches(REGION_SEL)) r = n; } catch (e) { return null; }
    }
    if (!r && /\/cart\/?$/.test(location.pathname)) r = document.body;
    return r;
  }

  // the item of the product row an element is in: the first parent that names exactly one cart item
  function rowOf(t) {
    var region = regionOf(t);
    if (!region) return null;
    for (var n = t, d = 0; n && n.nodeType === 1 && d < 30; n = n.parentElement, d++) {
      if (bar && (n === bar || bar.contains(n))) return null;
      var r = identify(n);
      if (r.state === 'one') return r.key;
      if (r.state === 'many') return null;
      if (n === region) return null;
    }
    return null;
  }

  // the moment the customer touches a cart row, remember which item it is (capture phase: before the theme)
  var lastTarget = null, lastTargetT = 0;
  function onTouch(e) {
    try {
      var t = e.target, tn = now();
      if (!t || t.nodeType !== 1 || !lastCart) return;
      if (t === lastTarget && tn - lastTargetT < 60) { if (lastClick) lastClick.t = tn; return; }
      lastTarget = t; lastTargetT = tn;
      var key = rowOf(t);
      if (key) lastClick = { key: key, t: tn };
    } catch (err) { /* never break the theme */ }
  }
  ['pointerdown', 'mousedown', 'touchstart', 'click', 'keydown', 'input', 'change', 'focusin'].forEach(function (type) {
    window.addEventListener(type, onTouch, true);
  });

  // =====================================================================
  //  Theme cart request -> the item the customer really clicked (synchronous, no waiting)
  // =====================================================================
  function scheduleResync(delay) {
    clearTimeout(resyncTimer);
    resyncTimer = setTimeout(function () { schedule(0); }, delay || 700);   // the theme redraws from its own answer; we update the bar
  }

  function noChange(note) {
    var items = (lastCart && lastCart.items) || [];
    scheduleResync(600);
    if (!items.length) return null;
    return { id: items[0].key, quantity: items[0].quantity, note: note };
  }

  function fixFor(line, id) {
    if (!lastCart) return null;
    if (line != null && line !== '') {
      var n = parseInt(line, 10);
      if (!(n >= 1)) return null;
      var c = lastClick;
      if (!c || now() - c.t > CLICK_TTL) return null;          // no click on a row: leave it to the theme
      var ck = canonical(c.key);
      var it = lastCart.items[n - 1];
      if (it && it.key === ck) return null;                    // theme and click agree: send as it is
      if (currentKeys[ck]) return { id: ck, note: 'line ' + n + ' -> ' + label(ck) };
      if (!isGone(c.key)) return null;                         // not sure: leave it to the theme
      return noChange('line ' + n + ': ' + label(c.key) + ' already gone, sent as no-change');
    }
    if (id != null && String(id).indexOf(':') > -1) {
      var key = String(id).toLowerCase();
      if (currentKeys[key] || !knownItems[key]) return null;   // valid key, or one we know nothing about
      var nk = canonical(key);
      if (currentKeys[nk]) return { id: nk, note: 'old item code of ' + label(nk) + ' -> current code' };
      if (!isGone(key)) return null;
      return noChange(label(key) + ' already gone, sent as no-change');
    }
    return null;
  }

  // works on anything with get/set/delete: URLSearchParams, FormData, or a plain object
  function applyFix(get, set, del) {
    var line = get('line');
    var fx = fixFor(line, line == null ? get('id') : null);
    if (!fx) return null;
    del('line');
    set('id', fx.id);
    if (fx.quantity != null) set('quantity', fx.quantity);
    return fx.note;
  }

  function fixParams(p) {
    return applyFix(function (k) { return p.has(k) ? p.get(k) : null; },
      function (k, v) { p.set(k, String(v)); },
      function (k) { p.delete(k); });
  }

  // returns { url?, body?, note } or null to send the request untouched
  function fixRequest(url, body) {
    var res = {}, notes = [], note;
    try {
      var u = new URL(url, location.href);
      if (u.searchParams.has('line') || u.searchParams.has('id')) {
        note = fixParams(u.searchParams);
        if (note) { res.url = u.href; notes.push(note); }
      }
    } catch (e) { /* bad url: ignore */ }

    if (body != null && !notes.length) {
      if (typeof body === 'string') {
        if (body.replace(/^\s+/, '').charAt(0) === '{') {
          var o = null;
          try { o = JSON.parse(body); } catch (e) { o = null; }
          if (o && typeof o === 'object') {
            note = applyFix(function (k) { return o[k] == null ? null : o[k]; },
              function (k, v) { o[k] = v; },
              function (k) { delete o[k]; });
            if (note) { res.body = JSON.stringify(o); notes.push(note); }
          }
        } else if (/(^|&)(line|id)=/.test(body)) {
          var sp = new URLSearchParams(body);
          note = fixParams(sp);
          if (note) { res.body = sp.toString(); notes.push(note); }
        }
      } else if (typeof URLSearchParams !== 'undefined' && body instanceof URLSearchParams) {
        var sp2 = new URLSearchParams(body.toString());
        note = fixParams(sp2);
        if (note) { res.body = sp2; notes.push(note); }
      } else if (typeof FormData !== 'undefined' && body instanceof FormData) {
        note = fixParams(body);                              // FormData is changed in place
        if (note) { res.body = body; notes.push(note); }
      }
    }
    if (!notes.length) return null;
    lastFix = notes.join(', ');
    trace('fixed theme cart request: ' + lastFix);
    scheduleResync(900);                                     // make sure the drawer shows the result
    return res;
  }

  function isThemeCart(url) { return !!url && CART_CHANGE.test(url) && url.indexOf(TAG) === -1; }
  function mayFix(url) { return !!url && CART_LINE_REQ.test(url) && url.indexOf(TAG) === -1; }

  function installHooks() {
    var nf = nativeFetch;
    window.fetch = function (input, init) {
      var url = null, fx = null, p;
      try {
        if (typeof input === 'string') url = input;
        else if (window.URL && input instanceof URL) url = input.href;
        else if (input && typeof input.url === 'string') url = input.url;
        if (mayFix(url) && (typeof input === 'string' || (window.URL && input instanceof URL))) fx = fixRequest(url, init && init.body);
      } catch (e) { fx = null; }
      if (fx) {
        var ninit = {};
        if (init) for (var k in init) ninit[k] = init[k];
        if (fx.body !== undefined) ninit.body = fx.body;
        p = nf.call(window, fx.url || input, ninit);
      } else {
        p = nf.apply(this, arguments);
      }
      if (isThemeCart(url)) {
        // read the theme's answer too, so we always know the real cart order
        p.then(function (r) {
          try { if (r && r.ok) r.clone().json().then(remember, function () {}); } catch (e) { /* ignore */ }
        }, function () {});
      }
      return p;
    };

    var X = window.XMLHttpRequest && XMLHttpRequest.prototype;
    if (!X) return;
    var xo = X.open, xs = X.send, xh = X.setRequestHeader;
    X.open = function (method, url, async) {
      try { this.__mrx = { method: method, url: String(url), async: arguments.length < 3 ? true : async, headers: [] }; } catch (e) { /* ignore */ }
      return xo.apply(this, arguments);
    };
    X.setRequestHeader = function (k, v) {
      try { if (this.__mrx) this.__mrx.headers.push([k, v]); } catch (e) { /* ignore */ }
      return xh.apply(this, arguments);
    };
    X.send = function (body) {
      var x = this, m = x.__mrx, fx = null;
      try {
        if (m && isThemeCart(m.url)) {
          x.addEventListener('load', function () {
            try {
              if (x.status < 200 || x.status >= 300) return;
              if (x.responseType === 'json') remember(x.response);
              else if (!x.responseType || x.responseType === 'text') remember(JSON.parse(x.responseText));
            } catch (e) { /* not JSON */ }
          });
        }
        if (m && mayFix(m.url)) fx = fixRequest(m.url, body);
        if (fx && fx.url) {
          xo.call(x, m.method, fx.url, m.async);
          for (var i = 0; i < m.headers.length; i++) xh.call(x, m.headers[i][0], m.headers[i][1]);
        }
      } catch (e) { fx = null; }
      if (fx && fx.body !== undefined) return xs.call(x, fx.body);
      return xs.apply(x, arguments);
    };
  }
  installHooks();

  // =====================================================================
  //  Main loop
  // =====================================================================
  function schedule(delay) {
    clearTimeout(timer);
    timer = setTimeout(run, delay == null ? 60 : delay);
  }

  function makeView(m) {
    return { eligible: m.eligible, unlocked: m.unlocked, hasItems: m.hasItems, giftShown: m.gifts.length > 0, dismissed: getFlag() === 'dismissed' };
  }

  // Part 1 (read cart, update the bar) is quick and never waits for anything.
  // Part 2 (add/remove the gift, refresh the drawer) runs one at a time.
  async function run() {
    var my = ++seq;
    ran = true;
    var cart;
    try { cart = await getCart(); } catch (e) { log('cart.js failed', e); return; }
    if (my !== seq) return;                         // a newer check already started, it will do the work
    var m = measure(cart);
    view = makeView(m);
    ensureBar();

    if (busy) { again = true; return; }
    busy = true;
    try {
      var action = decide(m);
      trace('check: items=' + m.others.length + ' eligible=' + Math.round(m.eligible / 100) + ' unlocked=' + m.unlocked + ' gift=' + m.gifts.length + ' flag=' + getFlag() + ' action=' + (action ? action.type : 'none'));
      var changed = action ? await perform(action) : false;
      if (changed) { cart = await getCart(); m = measure(cart); }
      view = makeView(m);
      ensureBar();
      if (changed) {
        lastRefresh = nudgeTheme();
        trace('theme refresh: ' + lastRefresh);
        setTimeout(ensureBar, 400);
        setTimeout(ensureBar, 1200);
      }
    } catch (e) {
      trace('error ' + (e && e.message));
    } finally {
      busy = false;
      if (again) { again = false; schedule(60); }
    }
  }

  // ---------- progress bar ----------
  function css() {
    if (document.getElementById(BAR_ID + '-css')) return;
    var s = document.createElement('style');
    s.id = BAR_ID + '-css';
    s.textContent =
      '#' + BAR_ID + '{padding:14px 20px;border-bottom:1px solid #e5e5e5;background:#fff;font-family:inherit}' +
      '#' + BAR_ID + ' p{margin:0 0 8px;font-size:12px;font-weight:600;letter-spacing:.08em;text-transform:uppercase;line-height:1.4}' +
      '#' + BAR_ID + ' .mrx-track{height:4px;background:#eee;overflow:hidden}' +
      '#' + BAR_ID + ' .mrx-fill{height:100%;background:#000;transition:width .4s ease}';
    document.head.appendChild(s);
  }

  // find the "SHOPPING CART" heading of the drawer. Cached, so this is cheap after the first hit.
  function findHeader() {
    if (header && header.isConnected) return header;
    header = null;
    if (!document.body) return null;
    var w = document.createTreeWalker(document.body, NodeFilter.SHOW_TEXT, null, false);
    var n, fallback = null;
    while ((n = w.nextNode())) {
      var v = n.nodeValue;
      if (!v || v.length > 30 || !/^\s*shopping\s+cart\s*$/i.test(v)) continue;
      var leaf = n.parentElement;
      if (!leaf || /^(SCRIPT|STYLE|NOSCRIPT|TITLE|OPTION)$/.test(leaf.nodeName) || !leaf.parentElement) continue;
      if (leaf.closest && leaf.closest('[id*="cart" i],[class*="cart" i],[id*="drawer" i],[class*="drawer" i]')) { header = leaf.parentElement; return header; }
      if (!fallback) fallback = leaf.parentElement;
    }
    header = fallback;
    return header;
  }

  function barContent() {
    var pct = Math.min(100, Math.round((view.eligible * 100) / THRESHOLD));
    var text;
    if (view.unlocked) {
      text = view.giftShown ? 'Free ' + CONFIG.giftName + ' unlocked, added to your order' : 'Free ' + CONFIG.giftName + ' unlocked';
    } else {
      text = money(THRESHOLD - view.eligible) + ' away from a free ' + CONFIG.giftName;
    }
    return { key: pct + '|' + text, html: '<p>' + text + '</p><div class="mrx-track"><div class="mrx-fill" style="width:' + pct + '%"></div></div>' };
  }

  function ensureBar() {
    if (!view) return;
    var h = findHeader();
    if (!h || !h.parentNode) return;
    css();
    if (!bar) { bar = document.createElement('div'); bar.id = BAR_ID; }
    var c = barContent();
    if (bar.getAttribute('data-key') !== c.key) { bar.setAttribute('data-key', c.key); bar.innerHTML = c.html; }
    bar.style.display = view.hasItems ? '' : 'none';
    if (!bar.isConnected || bar.previousElementSibling !== h) h.insertAdjacentElement('afterend', bar);
    watch(h);
  }

  // if the theme rebuilds the drawer, put the bar back. Only the heading's parent is observed, direct children only.
  function watch(h) {
    var p = h.parentElement;
    if (!p || p === watched || !window.MutationObserver) return;
    if (mo) mo.disconnect();
    watched = p;
    mo = new MutationObserver(function () {
      if (bar && !bar.isConnected) { clearTimeout(barTimer); barTimer = setTimeout(ensureBar, 60); }
    });
    mo.observe(p, { childList: true });
  }

  // ---------- ask the theme to redraw its own drawer ----------
  // The script never changes the theme's drawer HTML (only its own progress bar): Kalles keeps references
  // to its drawer parts, and replacing them left the drawer stuck on the grey loading skeleton.
  // After the script added/removed the Shoe Tree it only sends the usual "cart changed" signals.
  // If the theme ignores them, the drawer catches up on its next own update; deleting and +/- still hit
  // the right product, because the clicked row is recognised by its name.
  function nudgeTheme() {
    if (!CONFIG.refreshTheme) return 'disabled';
    try { document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { open: false } })); } catch (e) { /* ignore */ }
    try { if (window.jQuery) window.jQuery(document).trigger('cart:refresh'); } catch (e) { /* ignore */ }
    return 'signal sent';
  }

  // opening the drawer: bring the bar up to date (the theme loads its own drawer content)
  function checkDrawer() { if (!busy) schedule(0); }

  // ---------- listen for the theme's cart requests ----------
  function watchNetwork() {
    try {
      var po = new PerformanceObserver(function (list) {
        var es = list.getEntries();
        for (var i = 0; i < es.length; i++) {
          var u = es[i].name;
          if (isThemeCart(u)) {
            trace('theme cart request ' + u.replace(/^https?:\/\/[^/]+/, '').slice(0, 40));
            schedule(60);
            return;
          }
        }
      });
      po.observe({ type: 'resource' });
      return true;
    } catch (e) { return false; }
  }
  var networkWatch = watchNetwork();

  document.addEventListener('click', function (e) {
    try {
      var t = e.target;
      if (!t || !t.closest) return;
      if (t.closest('a[href$="/cart"],[class*="cart" i],[id*="cart" i]')) {
        if (!ran) schedule(50);
        else if (!networkWatch) schedule(1500);      // old browsers without PerformanceObserver
        setTimeout(ensureBar, 300);
        setTimeout(ensureBar, 900);
      }
      // opening the drawer from the header: make sure it shows the real cart
      if (t.closest('a[href$="/cart"]')) setTimeout(checkDrawer, 500);
    } catch (err) { /* never break a click */ }
  }, true);

  window.addEventListener('pageshow', function (e) {
    if (e.persisted) { schedule(100); setTimeout(function () { checkDrawer(true); }, 300); }
  });
  document.addEventListener('visibilitychange', function () { if (!document.hidden && ran) { schedule(300); setTimeout(checkDrawer, 600); } });

  function hasCartCookie() { try { return /(?:^|;\s*)cart=/.test(document.cookie); } catch (e) { return true; } }
  function boot() { if (hasCartCookie()) schedule(0); }
  if (window.requestIdleCallback) requestIdleCallback(boot, { timeout: 2500 });
  else setTimeout(boot, 1200);

  // for troubleshooting: mrxGift.debug() in the browser console
  window.mrxGift = {
    // read by snippets/product-addons.liquid so Buy it now uses the same threshold and gift
    config: { thresholdPkr: CONFIG.thresholdPkr, giftVariantId: CONFIG.giftVariantId },
    run: function () { schedule(0); },
    debug: function () {
      return {
        view: view, flag: getFlag(), lastRefresh: lastRefresh, lastFix: lastFix,
        lastClick: lastClick ? { item: label(lastClick.key), secondsAgo: Math.round((now() - lastClick.t) / 1000) } : null,
        cart: lastCart ? lastCart.items.map(function (i) { return i.quantity + ' x ' + i.product_title; }) : null,
        headerFound: !!findHeader(), networkWatch: networkWatch,
        pausedUntil: pausedUntil, failUntil: failUntil, trace: traceLog.slice()
      };
    }
  };
})();